import React from "react";
import { TextOverflow } from "utils/common";
import { adType } from "reducers/common/dictionaries";

export default function AdTypeCell({ value }){
	let uiLabel = adType.apiToUI[value] || value;

	return <TextOverflow value={uiLabel} />;
}

AdTypeCell.displayName = "AdTypeCell";
